import { createFileRoute } from "@tanstack/react-router";
import { FilesTable } from "./-components/allocation-table";

export const Route = createFileRoute("/_main/products/allocation/")({
  component: RouteComponent,
});

function RouteComponent() {
  // Mock data for the files table
  const mockFilesData = [
    {
      id: "1",
      fileName: "Weekly Fresh Produce.xls",
      fileSize: "200 KB",
      status: "Active" as const,
      dateCreated: "2024-01-04T00:00:00Z",
      products: 14,
      orders: 45,
    },
    {
      id: "2",
      fileName: "Monthly Dairy Products.xls",
      fileSize: "200 KB",
      status: "Active" as const,
      dateCreated: "2024-01-04T00:00:00Z",
      products: 18,
      orders: 8,
    },
    {
      id: "3",
      fileName: "Seasonal Fruits.xls",
      fileSize: "200 KB",
      status: "Expired" as const,
      dateCreated: "2024-01-02T00:00:00Z",
      products: 12,
      orders: 12,
    },
    {
      id: "4",
      fileName: "Organic Vegetables",
      fileSize: "200 KB",
      status: "Active" as const,
      dateCreated: "2024-01-02T00:00:00Z",
      products: 23,
      orders: 7,
    },
  ];

  return (
    <div className="px-4 py-6">
      <FilesTable data={mockFilesData} />
    </div>
  );
}
